import { featuredDramas } from "@/mocks/content";

export default function FeaturedSection() {
  return (
    <section id="featured" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="max-w-2xl" data-reveal>
          <h2 className="font-heading font-semibold text-2xl md:text-3xl text-foreground-950">
            编辑精选：本期优先看的三个方向
          </h2>
          <p className="mt-3 text-foreground-600 leading-8">
            从全部条目里挑出三部，分别对应家庭伦理、代际理解与职场成长三种关注点。
            它们各自回答一个不同的问题，适合作为了解这个题材的起点。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuredDramas.map((item, index) => (
            <article
              key={item.title}
              data-reveal
              className="group flex flex-col rounded-xl overflow-hidden bg-background-100 border border-background-200"
            >
              <div className="relative w-full h-48 md:h-52 bg-background-200 overflow-hidden">
                <img
                  src={item.poster}
                  alt={`${item.title} 题材插画`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-50/95 text-primary-700 text-xs font-medium">
                  <i
                    className={
                      index === 1 ? "ri-pulse-line" : index === 2 ? "ri-line-chart-line" : "ri-medal-line"
                    }
                    aria-hidden="true"
                  ></i>
                  {item.reason}
                </span>
              </div>
              <div className="flex flex-col flex-1 p-5">
                <h3 className="font-heading font-semibold text-lg text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs text-secondary-700">{item.meta}</p>
                <p className="mt-3 text-sm text-foreground-600 leading-7 flex-1">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}